import React from 'react';
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";
import {DateFormatter, remoteOptionFormatter} from "../../../utils/formatters";
import PrintButton from "../../form/PrintButton";
import Button from "../../form/Button";
import {postData} from "../../../utils/request";
import {optionFilter} from "../../../utils/filters";

class RoyaltyReportList extends React.Component {

    refresh = () => {
        this.list && this.list.refresh();
    }

    refreshBackground = () => {
        this.list && this.list.refreshBackground();
    }

    render() {
        const filterable = true;
        const sortable = true;
        const {view, componentConfig, filter, selection, isLoading, selectionMode} = this.props;
        const props = {componentConfig, filter, loading: isLoading, pageSize: 5, formId: this.props.formId};
        if (view) {
            props.view = view;
        }
        if (Array.isArray(props.view)) {
            props.view = [...props.view, "licensor"];
        } else if (props.view instanceof Object) {
            props.view = {...props.view, licensor: ""};
        } else {
            props.view = ["licensor"];
        }
        if (this.props.filter) {
            props.filter = [...props.filter];
        } else {
            props.filter = [];
        }
        return (
            <SelectorGrid
                className={"p-small-table"}
                selectionMode={selectionMode}
                selection={this.props.actions !== true ? selection : null}
                ref={(el) => this.list = el}
                gridid={this.props.gridid !== undefined ? this.props.gridid : "RoyaltyReportList"}
                {...props}
                orderBy={{field: componentConfig.idfield, direction: "DESC"}}
                columns={{
                    "report_date": {
                        header: 'Dátum',
                        width: 2,
                        sortable,
                        filterable,
                        renderer: DateFormatter
                    },
                    ...(this.props.actions === true ? {"licensor.name": {
                        header: 'Partner',
                        width: 2,
                        sortable,
                        filterable,
                    },
                    "action.view": {
                        header: " ",
                        width: 1,
                        renderer: (v, rowData) => {
                            return (
                                <PrintButton
                                    {...this.props}
                                    values={rowData}
                                    block={true}
                                    size="xs"
                                    icon={{lib: "fas", name: "download"}}
                                    color="default"
                                    disabled={this.props.isLoading}
                                >
                                    Letöltés
                                </PrintButton>
                            );
                        }
                    },
                    "action.send": {
                        header: " ",
                        width: 1,
                        renderer: (v, rowData) => {
                            return (
                                <Button
                                    block={true}
                                    color="default"
                                    size="xs"
                                    icon={{lib: "fa", name: "paper-plane"}}
                                    disabled={this.props.isLoading}
                                    onClick={() => {
                                        this.props.processAction(async () => {
                                            return await postData({
                                                action: 'RoyaltyReport.send',
                                                [this.props.componentConfig.idfield]: rowData[this.props.componentConfig.idfield]
                                            });
                                        });
                                    }}
                                >
                                    Küldés
                                </Button>
                            );
                        }
                    }} : {}),
                    "state": {
                        header: "Állapot",
                        width: 1,
                        operator: "=",
                        filterable: optionFilter("RoyaltyReportStatus"),
                        renderer: remoteOptionFormatter("RoyaltyReportStatus")
                    }
                }}
                onSelectionChange={(selection) => this.props.actions !== true && this.props.loadForm(selection.value)}
            />
        );
    }
}

export default RoyaltyReportList;
